import { useNetworkStatus } from "@/hooks/use-network-status";
import { cn } from "@/lib/utils";
import { useState } from "react";
import { Trans } from "react-i18next";
import { OctagonAlert, X } from "lucide-react";

export function OfflineWarning() {
  const networkStatus = useNetworkStatus();
  const [isOpen, setIsOpen] = useState(true);

  const shouldShow = networkStatus.data !== "disconnected";

  if (!isOpen) {
    return (
      <div
        onClick={() => setIsOpen(true)}
        className={cn(
          "fixed top-[150px] right-[5vw] z-90 w-fit animate-in slide-in-from-top duration-300 flex justify-center",
          shouldShow && "hidden",
        )}
      >
        <div className="bg-amber-500/75 backdrop-blur-sm px-4 py-2.5 shadow-md w-fit min-w-0 flex mx-auto rounded-xl">
          <OctagonAlert className="size-8" />
        </div>
      </div>
    );
  }

  return (
    <div
      onClick={() => setIsOpen(false)}
      className={cn(
        "fixed top-[200px] left-[5vw] right-0 z-90 w-[90vw] animate-in slide-in-from-top duration-300 flex justify-center",
        shouldShow && "hidden",
      )}
    >
      <X className="absolute top-2 right-2 text-black z-100" />
      <div className="bg-amber-500/75 backdrop-blur-sm px-4 py-2.5 shadow-md w-fit min-w-0 flex mx-auto rounded-xl">
        <div className="flex items-center min-w-0 gap-2 text-lg font-medium text-amber-950">
          <span className="text-[52px] leading-[1em] text-center">
            <Trans>
              Figyelem: a gép korlátozott funkciókkal és fizetési módokkal
              működik
            </Trans>
          </span>
        </div>
      </div>
    </div>
  );
}
